export const Usd1PointsEvent = {
  Usd1PageLearnMoreClick: 'usd1_page_learn_more_click',
  Usd1PageViewHistoryClick: 'usd1_page_view_history_click',
  Usd1PageDepositClick: 'usd1_page_deposit_click',
} as const;

export interface Usd1PointsEventDataType {
  [Usd1PointsEvent.Usd1PageLearnMoreClick]: {};
  [Usd1PointsEvent.Usd1PageViewHistoryClick]: {};
  [Usd1PointsEvent.Usd1PageDepositClick]: {};
}
